<template>
  <div class="point_error">
    <section class="text_center">
      <h2 class="header_underline">クレジット決済エラー</h2>
      <p class="point_error_notice">クレジット決済でエラーが発生しました。</p>
      <p>
        <router-link :to="{ name: 'PointCreditTelecomForm' }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PointCreditTelecomError'
}
</script>
